import { Axios } from "../axios";
import IRemittance from "./remittance";

export const getTransactionSummary = async (
  body: IRemittance.GettransactionSummaryProps,
  idToken: string
) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/user/getTransactionSummary", body, {
      headers: {
        Authorization: `${idToken}`,
      },
    });
  }
};

export const bookRate = async (body: IRemittance.BookRateProps, idToken: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/user/rate/book", body, {
      headers: {
        Authorization: `${idToken}`,
      },
    });
  }
};

export const getAdditionalDox = async (purposeCode: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserKey = localStorage.getItem("vendorUserKey");
  const recipient = JSON.parse(localStorage.getItem("recipient_id") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `remit/user/${vendorUserKey}/lead/upload/doc/${recipient}?purposeCode=${purposeCode}`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};

export const fxRates = async (dest_currency: string) => {
  const userKey = localStorage.getItem("userKey") || "";
  const userToken = localStorage.getItem("userToken") || "";
  return await Axios.get(`/remit/fxRates/${userKey}/latest?base=inr&symbols=${dest_currency}`, {
    headers: {
      Authorization: `${userToken}`,
    },
  });
};
